import React, { useState, useEffect, useContext } from "react";
import Loading from "./Loading";
import KwordTabs from "./KwordTabs";
import DisAllowedAccess from "./DisAllowedAccess";

import MessageBox from "./MessageBox";
import ErrorBox from "./ErrorBox";

// import getTokenObject from "./JsFiles/GetTokenObject";
import Accesses from "./JsFiles/Accesses";
import * as APICalls from "./JsFiles/APICalls";
import "../style/general.css";

export default function App(title) {
  const [decodedTokenObject, setDecodedTokenObject] = useState({});
  const [workItemObject, setWorkItemObject] = useState({});
  const [userInfoObject, setUserInfoObject] = useState({});
  const [state, setState] = useState("loading");
  const [accessesObject, setAccessesObject] = useState({});
  const [reloadApp, setReloadApp] = useState(false);
  const [notAccessReason, setNotAccessReason] = useState("");
  const [messageBoxProp, setMessageBoxProp] = useState("");
  const [errorBoxProp, setErrorBoxProp] = useState("");

  useEffect(() => {
    console.log("27.05");
    handleLogin();
  }, [reloadApp]);

  useEffect(() => {
    // APICalls.js raises this event after a silent token refresh, so the app
    // keeps using a valid access token for the rest of the editing session.
    const handleTokenRefreshed = (event) => {
      setDecodedTokenObject((decodedTokenObject) => Object.assign({}, decodedTokenObject, event.detail));
    };
    window.addEventListener(APICalls.TOKEN_REFRESHED_EVENT, handleTokenRefreshed);
    return () => window.removeEventListener(APICalls.TOKEN_REFRESHED_EVENT, handleTokenRefreshed);
  }, []);

  useEffect(() => {
    if (state == "LoggedIn") {
      const userInfoObjectPromise = APICalls.getUserInfoByObjectId(
        decodedTokenObject.uniqueId,
        decodedTokenObject
      );
      const workItemObjectPromise = APICalls.getWorkItemInfo(decodedTokenObject);
      workItemObjectPromise.catch(() => {
        setAccessFalse("notKarnovDocument");
      });
      userInfoObjectPromise.catch(() => {
        setAccessFalse("notKarnovUser");
      });
      Promise.all([userInfoObjectPromise, workItemObjectPromise]).then(
        ([userInfoObjectPromiseResult, workItemObjectPromiseResult]) => {
          if (userInfoObjectPromiseResult.Id && workItemObjectPromiseResult.Id) {
            setWorkItemObject((workItemObject) => {
              return Object.assign(workItemObject, workItemObjectPromiseResult);
            });
            setUserInfoObject((userInfoObject) => {
              return Object.assign(userInfoObject, userInfoObjectPromiseResult);
            });
            setAccessesObject(Accesses(userInfoObjectPromiseResult, workItemObjectPromiseResult));
            setState("Finished");
            sendMetric("OpenInWord", Office.context.platform, "Success");
            sendLog("INFO", "Login success");
          } else if (userInfoObjectPromiseResult.Id && !workItemObjectPromiseResult.Id) {
            // the document is not a karnov document
            setAccessFalse("notKarnovDocument");
          } else if (!userInfoObjectPromiseResult.Id && workItemObjectPromiseResult.Id) {
            // the user is not allowed to use Kword
            setAccessFalse("notKarnovUser");
          }
        }
      );
    }
  }, [state]);

  const handleLogin = async () => {
    sendLog("INFO", "Init Ktext");
    sendMetric("Init", "", "Success", Office.context.platform);
    setState("LoggingIn");
    const dialogLoginUrl =
      location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "") +
      "/login.html";
    Office.context.ui.displayDialogAsync(
      dialogLoginUrl,
      { height: 40, width: 30 },
      async (result) => {
        if (result.status === Office.AsyncResultStatus.Failed) {
          displayError(`${result.error.code} ${result.error.message}`);
        } else {
          Office.Dialog = result.value;
          Office.Dialog.addEventHandler(
            Office.EventType.DialogMessageReceived,
            processLoginMessage
          );
        }
      }
    );
  };

  const processLoginMessage = (res) => {
    let msg = JSON.parse(res.message);
    if (msg.status === "success") {
      // We now have a valid access token.
      // The new sign-in replaces earlier refreshed tokens and makes a running refresh void.
      APICalls.resetTokenRefresh();

      if (APP_Environment == "local") {
        console.log("decodedTokenObject in local env", decodedTokenObject);
      }
      setDecodedTokenObject((decodedTokenObject) => {
        return Object.assign(decodedTokenObject, msg.result);
      });

      Office.Dialog.close();
      setState("LoggedIn");
    } else {
      // Something went wrong with authentication or the authorization of the web application.
      displayError(msg.result);
      setAccessFalse("authenticationFailed");
    }
  };

  const setAccessFalse = (reason) => {
    setNotAccessReason(reason);
    let logType;
    let logMsg;
    switch (reason) {
      case "notKarnovUser":
        logMsg = "A non Karnov user Opening Ktext";
        logType = "ERROR";
        break;
      case "notKarnovDocument":
        logMsg = "Opening a non karnov document with Ktext";
        logType = "WARNING";
        break;
      case "authenticationFailed":
        logMsg = "An error when Kword wants to get token";
        logType = "ERROR";
        break;
      default:
        logMsg = "Unknown reason";
        logType = "ERROR";
        break;
    }
    sendLog(logType, logMsg, reason);
    setAccessesObject((accessesObject) => ({
      ...accessesObject,
      HasAccess: false,
    }));
    setState("Finished");
  };

  const sendLog = (level, message, method, params) => {
    APICalls.log(
      level,
      message,
      method,
      params,
      workItemObject,
      userInfoObject,
      decodedTokenObject
    );
  };

  const sendMetric = (category, subCategory, status, tag, message) => {
    APICalls.logMetric(
      category,
      subCategory,
      status,
      tag,
      message,
      workItemObject,
      userInfoObject,
      decodedTokenObject
    );
  };

  return (
    <React.Fragment>
      {state != "Finished" && <Loading state={state} />}
      {state == "Finished" && accessesObject.HasAccess == false && (
        <DisAllowedAccess reason={notAccessReason} />
      )}
      {state == "Finished" && accessesObject.HasAccess == true && (
        <decodedTokenObjectContext.Provider value={[decodedTokenObject, setDecodedTokenObject]}>
          <reloadAppContext.Provider value={[reloadApp, setReloadApp]}>
            <userInfoObjectContext.Provider value={[userInfoObject, setUserInfoObject]}>
              <workItemObjectContext.Provider value={[workItemObject, setWorkItemObject]}>
                <accessesObjectContext.Provider value={[accessesObject, setAccessesObject]}>
                  <messageBoxContext.Provider value={setMessageBoxProp}>
                    <errorBoxContext.Provider value={setErrorBoxProp}>
                      <MessageBox type={messageBoxProp} />
                      <ErrorBox type={errorBoxProp} />
                      <KwordTabs />
                    </errorBoxContext.Provider>
                  </messageBoxContext.Provider>
                </accessesObjectContext.Provider>
              </workItemObjectContext.Provider>
            </userInfoObjectContext.Provider>
          </reloadAppContext.Provider>
        </decodedTokenObjectContext.Provider>
      )}
    </React.Fragment>
  );
}

export const userInfoObjectContext = React.createContext();
export const workItemObjectContext = React.createContext();
export const accessesObjectContext = React.createContext();
export const decodedTokenObjectContext = React.createContext();
export const reloadAppContext = React.createContext();
export const messageBoxContext = React.createContext();
export const errorBoxContext = React.createContext();
